import { useLazyQuery } from '@apollo/client';

import { useEffect } from 'react';

import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { GetCustomerContractsCount, GetCustomerContractsCountVariables } 
  from '@/graphql/contracts/_generated_/GetCustomerContractsCount.query';
import GetCustomerContractsCountQuery from '@/graphql/contracts/GetCustomerContractsCount.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetContractsCount() {
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const [_getContractsCount, { data, loading }] = useLazyQuery<
  GetCustomerContractsCount,
  GetCustomerContractsCountVariables
  >(GetCustomerContractsCountQuery, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
    fetchPolicy: 'network-only',
  });

  const getContractsCount = (customerId: string) => {
    return _getContractsCount({ variables: { customerId } });
  };

  useEffect(() => {
    toggleLoadingAnimation(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return {
    getContractsCount,
    contractsCountLoading: loading,
    contractsCount: data?.getCustomerContractsCount ?? 0,
  } as const;
}
